<script setup>
  const props = defineProps({
    user: { type: Object, default: null },
    showTooltip: { type: Boolean, default: true },
    size: { type: String, default: 'h-8 w-8' }
  })

  const avatarUrl = computed(() => {
    return props.user?.avatar?.url && !props.user?.anonymizedAt ? useStrapiMedia(props.user.avatar.url) : null
  })

  const initials = computed(() => {
    return `${props.user?.firstName?.[0].toUpperCase() ?? ''}${props.user?.lastName?.[0].toUpperCase() ?? ''}`
  })
</script>

<template>
  <Tooltip :content="showTooltip && user ? (user.fullName ?? user.email) : null">
    <div
      :class="`flex aspect-square ${size} items-center justify-center rounded-full bg-zinc-300 bg-cover bg-center text-tarawera-900 shadow`"
      :style="{
        backgroundImage: avatarUrl ? `url('${avatarUrl}')` : undefined
      }"
    >
      <Icon class="text-zinc-500" v-if="!props.user || props.user.anonymizedAt" name="question" />
      <small class="text-[0.9em] leading-[0]" v-else-if="!avatarUrl">{{ initials }}</small>
    </div>
  </Tooltip>
</template>
